module.exports = __webpack_public_path__ + "assets/img/w3.38e2a059.jpg";